import {absCenter} from '@xpertdox_js/xdstyle';

export default {
	warning: {
		fontSize: 15,
		marginTop: 0,
		color: 'rgb(230, 39, 18)',
		fontWeight: 600
	},
	textInput: {
		height: '30px',
		border: '1px solid #ccc',
		borderRadius: '1px',
		padding: '0 0 0 4px',
		minWidth: '100%'
	},
	button: {
		buttonHov: {
			opacity: .7,
		},
		buttonTxt: {
			...absCenter,
			display: 'block',
		},
		container: {
			position: 'display',
			fontWeight: 'bold',
			background: '#4d565d',
			height: 30,
			width: 100,
			fontSize: 12,
			color: '#f9f9f9',
			padding: 0,
			boxShadow: 'inset 0 -2px 8px -6px rgba(0,0,0,0.64)'
		},
	},
	list: {
		container: {
			listStyle: 'none',
			paddingLeft: 0,
			fontWeight: 600,
			fontSize: 14
		},
		listItem: {
      textAlign: 'left',
			background: '#EAECF054',
			border:' 1px solid rgba(0, 0, 0, 0.12)',
			padding: 8,
			marginBottom: 5,
			marginTop: 5,
			borderRadius: 2,
			position: 'relative',
			width: 'auto',
		},
	},
	questionEdit: {
		container: {
			marginTop: 40,
      marginBottom: 20,
			background: '#FAFDFE none repeat scroll 0% 0%',
			border: '1px solid rgba(0, 0, 0, 0.12)',
			padding: 8,
			borderRadius: 2,
			position: 'relative',
		},
		addOptionContainer: {
			display:'flex',
			flexDirection: 'row',
			alignItems: 'center',
			position: 'relative'
		},
		label: {
			marginBottom: 3,
			fontSize: '1.3rem'
		},
		check: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			marginBottom: 6,
			marginRight: 8
		},
		options: {
			marginTop: 10
		},
		addedOptionsContainer: {
			fontSize: 14,
			marginTop: 5
		}
	}
}
